export const init = () => {
    $('table').DataTable({
        dom: 'ftp',
        ordering: true,
        paging: false,
        language: {
            processing:     "Traitement en cours...",
            emptyTable:     "Aucun véhicule pour ce PV",
            search:         "Recherche:",
            paginate: {
                previous:   "Pr&eacute;c&eacute;dent",
                next:       "Suivant",
            },
        }});
    let buttonSelectToDissociate = document.querySelector('button[name="adjudication_dissociate[modalDissociateBySaleDefine]"]');
    buttonSelectToDissociate.addEventListener('click', () => {
        $('.modal').modal('show');
    });

};


// WEBPACK FOOTER //
// ./assets/js/edit_adjudication_dissociate.js